import React, { Component } from 'react'
import { Card, Col, Icon, Row, Tooltip } from 'antd'
import { get } from 'lodash'

import { strVal } from '../../../modules/Utils'
import Avatar from '../../People/Member/Avatar'

class Details extends Component {
  render() {
    const { member, government, loading } = this.props

    return (
      <Row>
        <Card title={<h1 style={{ fontWeight: 'bold' }}>{member.fn}</h1>} loading={loading} bordered={false} style={{}}>
          <Col span={5} style={{ margin: 'auto' }}>
            <Avatar id={member._key} />
          </Col>
          <Col span={8} style={{ margin: 'auto', paddingTop: '15px' }}>
            <h1 className={'icon-text-header'}>
              <Icon
                type="barcode"
                style={{
                  marginRight: '5px',
                  color: '#08c',
                }}
              />
              <Tooltip title="Government Code">{strVal(government, 'code')}</Tooltip>
            </h1>

            {!get(member, 'phone.label') &&
              !get(member, 'mobile.label') &&
              !get(member, 'email.label') &&
              !get(member, 'address.label') && (
                <h3>
                  <Icon type="info-circle" /> No Contact Details are available.
                </h3>
              )}
            {get(member, 'position') && <p>{strVal(member, 'position')}</p>}
            {get(member, 'phone.label') && (
              <span className={'icon-text'}>
                <Icon
                  type="phone"
                  style={{
                    paddingTop: '10px',
                    marginRight: '5px',
                    fontSize: 16,
                    color: '#08c',
                  }}
                />
                {strVal(member, 'phone.label')}
              </span>
            )}
            {get(member, 'mobile.label') && (
              <span className={'icon-text'}>
                <Icon
                  type="mobile"
                  style={{
                    paddingTop: '10px',
                    marginRight: '5px',
                    fontSize: 16,
                    color: '#08c',
                  }}
                />
                {strVal(member, 'mobile.label')}
              </span>
            )}
            {get(member, 'email.label') && (
              <p className={'icon-text'}>
                <Icon
                  type="mail"
                  style={{
                    paddingTop: '10px',
                    fontSize: 16,
                    marginRight: '5px',
                    color: '#08c',
                  }}
                />
                {strVal(member, 'email.label')}
              </p>
            )}
            {get(member, 'address.label') && (
              <p className={'icon-text'}>
                <Icon
                  type="home"
                  style={{
                    paddingTop: '10px',
                    marginRight: '5px',
                    fontSize: 16,
                    color: '#08c',
                  }}
                />
                {strVal(member, 'address.label')}
              </p>
            )}
          </Col>
        </Card>
      </Row>
    )
  }
}

export default Details
